module.exports = __webpack_public_path__ + "static/media/m14.56e8ae41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/merletto/m14.jpg
// module id = 435
// module chunks = 0